export default __webpack_public_path__ + "static/media/request.e4b370fc.svg";